import { CartProduct } from "@/interfaces";
import { formatCurrency, isFunction } from "@/utils";
import { CartHelper } from "@/helpers";
import CartProductItem from "../CartProductItem";
import Counter from "../Counter";
import * as S from "./styles";
import Link from "@mui/material/Link";
import { colors } from "@/theme";
import shippingIcon from "@/assets/shipping-icon.svg";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import quantityShipIcon from "@/assets/quantity-ship-icon.svg";
import CancelIcon from "@mui/icons-material/Cancel";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { useCart, useSettings } from "@/contexts";
import Box from "@mui/material/Box";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";

export type CartItemProps = {
  item?: CartProduct;
  defaultProductImageUrl?: string;
  onQuantityChange?: (id: number, value: number, type?: "in-store" | "shipping") => void;
  onCoopAppliedChange?: (id: number, value: number) => void;
  itemType?: "in-store" | "shipping";
};

const DialogCounter: React.FC<{
  label: string;
  value: number;
  onIncrement: () => void;
  onDecrement: () => void;
}> = ({ label, value, onIncrement, onDecrement }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
      <IconButton onClick={onDecrement}>
        <RemoveIcon />
      </IconButton>
      <div>{label}: {value}</div>
      <IconButton onClick={onIncrement}>
        <AddIcon />
      </IconButton>
    </div>
  );
};

// const DialogCounter: React.FC<{
//   value: number;
//   onChange: (value: number) => void;
//   maxValue?: number;
// }> = ({ value, onChange, maxValue }) => {
//   return (
//     <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
//       <IconButton
//         onClick={() => onChange(Math.max(0, value - 1))}
//         sx={{
//           padding: "8px",
//           marginRight: "8px",
//         }}
//       >
//         <RemoveIcon sx={{ fontSize: 20, color: colors.neutralGrey800 }} />
//       </IconButton>
//       <div
//         style={{
//           minWidth: "40px",
//           textAlign: "center",
//           fontSize: "16px",
//           fontWeight: 500,
//           color: colors.neutralGrey800,
//           fontFamily: "PF DIN Text Pro",
//         }}
//       >
//         {value}
//       </div>
//       <IconButton
//         onClick={() => onChange(Math.min(maxValue || Infinity, value + 1))}
//         sx={{
//           padding: "8px",
//           marginLeft: "8px",
//         }}
//       >
//         <AddIcon sx={{ fontSize: 20, color: colors.neutralGrey800 }} />
//       </IconButton>
//     </div>
//   );
// };

const CartItem: React.FC<CartItemProps> = ({
  item = undefined,
  defaultProductImageUrl = undefined,
  onQuantityChange,
  onCoopAppliedChange = undefined,
  itemType = "in-store",
}) => {
  const [shippingDialogOpen, setShippingDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [tempShippingQuantity, setTempShippingQuantity] = useState(0);
  const [inStoreQuantity, setInStoreQuantity] = useState(item?.quantity || 0);
  const [shippingQuantity, setShippingQuantity] = useState(item?.shippingQuantity || 0);
  const [editedRetailPrice, setEditedRetailPrice] = useState(item?.price || 0);

  const { settings } = useSettings();
  const { setProductPrice } = useCart();

  const handleIncreaseShipping = () => {
    console.log("handleIncreaseShipping: ", inStoreQuantity)
    if (inStoreQuantity > 0) {
      setInStoreQuantity(prev => prev - 1);
      setShippingQuantity(prev => prev + 1);
    }
  };

  const handleIncreaseInStore = () => {

    console.log("handleIncreaseInStore: ", shippingQuantity)
    if (shippingQuantity > 0) {
      setShippingQuantity(prev => prev - 1);
      setInStoreQuantity(prev => prev + 1);
    }
  };

  // const handleShippingDone = () => {
  //   console.log("handleShippingDone")
  //   if(!onQuantityChange) return;

  //   onQuantityChange(tempShippingQuantity, inStoreQuantity, "in-store");
  //   onQuantityChange(tempShippingQuantity, shippingQuantity, "shipping");
  //   setShippingDialogOpen(false);
  // };

  const handleShippingDone = () => {
    console.log("handleShippingDone");
    if (!onQuantityChange) return;

    onChange(inStoreQuantity, onQuantityChange, "in-store");
    onChange(shippingQuantity, onQuantityChange, "shipping");

    setShippingDialogOpen(false);
  };

  const onChange = (
    value: number,
    fn?: Function,
    type?: "in-store" | "shipping"
  ) => {
    if (isNaN(item?.productId as number) || isNaN(value) || !isFunction(fn)) {
      return;
    }

    console.log("onChange Items: ", value, " Type: ", type)
    fn?.(item?.productId as number, value, type);
  };

  const handleOpenShippingDialog = () => {
    setTempShippingQuantity(item?.shippingQuantity || 0);
    setShippingDialogOpen(true);
  };

  // const handleShippingDone = () => {
  //   onChange(tempShippingQuantity, onQuantityChange, "shipping");
  //   setShippingDialogOpen(false);
  // };

  const handleEditClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setEditDialogOpen(true);
  };

  const handleEditClose = () => {
    console.log("Edit clicked for product:", item);
    setEditDialogOpen(false);
    if (item?.productId) {
      setProductPrice(item.productId, editedRetailPrice); // ✅ Updates price + triggers co-op recalculation
    }
  };

  useEffect(() => {
    if (item) {
      console.log("Quantities: -InStore: ", item.quantity, " -Shipping: ", item.shippingQuantity);
      setInStoreQuantity(item.quantity || 0);
      setShippingQuantity(item.shippingQuantity || 0);
      setEditedRetailPrice(item.price || 0);
    }
  }, [item?.quantity, item?.shippingQuantity, item?.price]);


  return item ? (
    <S.CartItemRow>
      <S.CartItemProduct>
        <CartProductItem
          item={item}
          defaultProductImageUrl={defaultProductImageUrl}
          badge={false}
        />
      </S.CartItemProduct>
      <S.CartItemInfoBlock>
        <S.CartItemName>
          {item.productDescription}
          <BorderColorOutlinedIcon
            sx={{ fontSize: 20, marginLeft: 1, color: colors.neutralGrey800, cursor: 'pointer' }}
            onClick={handleEditClick}
          />
        </S.CartItemName>
        <S.CartItemSku style={{ fontFamily: "PF DIN Text Pro" }}>
          SKU# {item.sku}
        </S.CartItemSku>
        <S.CartItemPriceInfo style={{ fontFamily: "PF DIN Text Pro" }}>
          <span>{formatCurrency(item.price || 0)} Retail</span>
          <span>
            {formatCurrency((item.price || 0) - ((item.price || 0) * (settings?.coopEligible || 0)))} w/ Co-Op</span>
        </S.CartItemPriceInfo>
      </S.CartItemInfoBlock>
      <S.CartItemCounter>
        <Counter
          value={
            itemType === "in-store" ? item.quantity : item.shippingQuantity
          }
          onChange={(value: number) =>
            onChange(value, onQuantityChange, itemType)
          }
        />
      </S.CartItemCounter>
      <S.CartItemShipping>
        <Link
          href="#"
          underline="none"
          sx={{
            color: "#1a73e8",
            fontWeight: 500,
            fontSize: 14,
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontFamily: "PF DIN Text Pro",
          }}
          onClick={(e) => {
            e.preventDefault();
            handleOpenShippingDialog();
          }}
        >
          <img
            src={shippingIcon}
            alt="Shipping"
            style={{ width: "16px", height: "16px" }}
          />
          Change Shipping
        </Link>
      </S.CartItemShipping>
      <S.CartItemSubtotalInfo>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            // height: "60px",
            gap: "10px",
            textAlign: "right",
            width: "100%",
            fontFamily: "PF DIN Text Pro",
          }}
        >
          <div>
            <div
              style={{
                color: colors.neutralGrey800,
                fontSize: 16,
                fontWeight: 400,
                fontFamily: "PF DIN Text Pro",
              }}
            >
              {formatCurrency(
                itemType === "in-store" ?
                  CartHelper.getItemInStoreSubtotal(item) : CartHelper.getItemShippedSubtotal(item)
              )}{" "}
              Retail
            </div>
            <div
              style={{
                color: colors.neutralGrey800,
                fontSize: 16,
                fontWeight: 400,
                fontFamily: "PF DIN Text Pro",
              }}
            >
              -{formatCurrency(itemType === "in-store" ? (item.coopInStore || 0) : (item.coopShipping || 0) )} Co-Op
            </div>
          </div>
          <div
            style={{
              color: colors.primaryOzone500,
              fontWeight: 700,
              fontSize: 24,
              marginTop: 8,
              fontFamily: "PF DIN Text Pro",
            }}
          >
            {formatCurrency(
              itemType === "in-store"
                ? CartHelper.getItemInStoreSubtotal(item) - (item.coopInStore || 0)
                : CartHelper.getItemShippedSubtotal(item) - (item.coopShipping || 0)
            )}
          </div>
        </div>
      </S.CartItemSubtotalInfo>

      {/* Shipping Method Dialog */}
      <Dialog
        open={shippingDialogOpen}
        onClose={() => setShippingDialogOpen(false)}
        maxWidth="xs"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "8px",
            overflow: "hidden",
            padding: 0,
          },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: 600,
            fontSize: 16,
            position: "relative",
            p: 2,
            fontFamily: "PF DIN Text Pro",
            color: colors.neutralGrey800,
          }}
        >
          Change Shipping Method
          <IconButton
            aria-label="close"
            onClick={() => setShippingDialogOpen(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CancelIcon sx={{ color: colors.primaryOzone500 }} />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            p: 3,
            pb: 0,
          }}
        >
          <div
            style={{
              width: 335,
              height: 200,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#fff",
              border: "1px solid #eee",
              borderRadius: 8,
              marginBottom: 16,
            }}
          >
            {item && (
              <img
                src={item.productImageUrl || defaultProductImageUrl}
                alt={item.productDescription}
                title={item.productDescription}
                style={{
                  width: 185,
                  height: 184,
                  objectFit: "contain",
                  display: "block",
                }}
              />
            )}
          </div>
          <div
            style={{
              width: "335px",
              textAlign: "left",
              fontWeight: 600,
              fontSize: 18,
              marginBottom: 2,
              fontFamily: "PF DIN Text Pro",
              color: colors.neutralGrey800,
              textTransform: "capitalize",
            }}
          >
            {item?.productDescription}
          </div>
          <div
            style={{
              width: "335px",
              textAlign: "left",
              color: colors.neutralGrey800,
              fontSize: 13,
              marginBottom: 16,
              fontFamily: "PF DIN Text Pro",
            }}
          >
            SKU# {item?.sku}
          </div>
          <div
            style={{
              width: "335px",
              display: "flex",
              alignItems: "center",
              marginBottom: 12,
              marginLeft: 0,
              fontFamily: "PF DIN Text Pro",
              color: colors.neutralGrey800,
            }}
          >
            <span
              style={{
                display: "flex",
                alignItems: "center",
                fontWeight: 500,
                fontSize: 14,
                fontFamily: "PF DIN Text Pro",
              }}
            >
              <ShoppingCartOutlinedIcon
                sx={{
                  fontSize: 18,
                  marginRight: "4px",
                  color: colors.neutralGrey800,
                }}
              />
              Quantity In-Store
            </span>
            <div style={{ flex: 1 }} />
            <DialogCounter
              label="In Store"
              value={inStoreQuantity}
              // onChitem.quantityange={(value) =>
              //   onChange(value, onQuantityChange, "in-store")
              // }

              onIncrement={handleIncreaseInStore}
              onDecrement={handleIncreaseShipping}
            />
          </div>
          <div
            style={{
              width: "335px",
              display: "flex",
              alignItems: "center",
              marginBottom: 12,
              fontFamily: "PF DIN Text Pro",
              color: colors.neutralGrey800,
            }}
          >
            <span
              style={{
                display: "flex",
                alignItems: "center",
                fontWeight: 500,
                fontSize: 14,
                marginRight: 8,
                fontFamily: "PF DIN Text Pro",
              }}
            >
              <img
                src={quantityShipIcon}
                alt="To Ship"
                style={{ width: 18, height: 18, marginRight: 4 }}
              />
              Quantity to Ship
            </span>
            <div style={{ flex: 1 }} />
            <DialogCounter
              label="To Ship"
              value={shippingQuantity}
              // onChange={(value) => setTempShippingQuantity(value)}
              // maxValue={item.quantity}

              onIncrement={handleIncreaseShipping}
              onDecrement={handleIncreaseInStore}
            />
          </div>
        </DialogContent>
        <Button
          variant="contained"
          onClick={handleShippingDone}
          sx={{
            width: "100%",
            borderRadius: 0,
            py: 2,
            fontWeight: 500,
            fontSize: "16px",
            background: colors.primaryOzone500,
            boxShadow: "none",
            fontFamily: "PF DIN Text Pro",
            color: colors.white,
            "&:hover": {
              background: colors.primaryOzone500,
              boxShadow: "none",
            },
          }}
        >
          Done
        </Button>
      </Dialog>

      {/* Edit Dialog */}
      <Dialog
        open={editDialogOpen}
        onClose={handleEditClose}
        maxWidth="xs"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "8px",
            overflow: "hidden",
            padding: 0,
            width: "100%",
            maxWidth: "400px"
          },
        }}
      >
        <DialogTitle
          sx={{
            padding: "16px",
            position: "relative",
            textAlign: "center",
            fontFamily: "PF DIN Text Pro",
            fontSize: "18px",
            fontWeight: 500,
            color: colors.neutralGrey800,
          }}
        >
          Edit Item
          <IconButton
            onClick={handleEditClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: colors.primaryOzone500,
            }}
          >
            <CancelIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ padding: 0 }}>
          <Box sx={{ p: 3 }}>
            <Box sx={{
              width: "100%",
              height: "200px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: 3,
              bgcolor: colors.white,
              border: `1px solid ${colors.neutralGrey200}`,
              borderRadius: 1,
            }}>
              <img
                src={item.productImageUrl || defaultProductImageUrl}
                alt={item.productDescription}
                style={{
                  maxWidth: "80%",
                  maxHeight: "80%",
                  objectFit: "contain"
                }}
              />
            </Box>
            <Box sx={{ mb: 2 }}>
              <div style={{
                fontSize: "22px",
                fontWeight: 500,
                color: colors.neutralGrey800,
                marginBottom: "4px",
                fontFamily: "PF DIN Text Pro",
              }}>
                {item.productDescription}
              </div>
              <div style={{
                fontSize: "12px",
                color: colors.neutralGrey600,
                fontFamily: "PF DIN Text Pro",
              }}>
                SKU# {item.sku}
              </div>
            </Box>
            <Box sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              mb: 3,
            }}>
              <Typography sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: colors.neutralGrey800,
                fontFamily: "PF DIN Text Pro",
              }}>
                {formatCurrency(item.price || 0)} Retail
              </Typography>
              <TextField
                placeholder="Enter New Amount"
                variant="outlined"
                autoFocus
                size="small"
                value={editedRetailPrice}
                onChange={(e) => setEditedRetailPrice(parseFloat(e.target.value) || 0)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleEditClose();
                  }
                }}
                sx={{
                  flex: 1,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "4px",
                    backgroundColor: colors.white,
                    "& fieldset": {
                      borderColor: colors.neutralGrey300,
                    },
                  },
                  "& input": {
                    fontFamily: "PF DIN Text Pro",
                  },
                }}
              />
            </Box>
          </Box>
        </DialogContent>
        <Button
          onClick={handleEditClose}
          variant="contained"
          fullWidth
          sx={{
            bgcolor: colors.primaryOzone500,
            color: colors.white,
            py: 2,
            borderRadius: 0,
            fontSize: "16px",
            fontWeight: 500,
            textTransform: "none",
            fontFamily: "PF DIN Text Pro",
            "&:hover": {
              bgcolor: colors.primaryOzone500,
            },
          }}
        >
          Update Item
        </Button>
      </Dialog>
    </S.CartItemRow>
  ) : null;
};

export default CartItem;